// Footer.js
import React from 'react';
import './Footer.css'; // Import the CSS file for footer styling
// import logo from '../assets/LogoWhite.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">


        {/* Navigation Links */}
        <div className="footer-links">
          <h4>Support</h4>
          <ul>
            <li><a href="/"><i class="fa fa-chevron-right" aria-hidden="true"></i> Home</a></li>
            <li><a href="/company/about"><i class="fa fa-chevron-right" aria-hidden="true"></i> About Us</a></li>
            {/* <li><a href="/products"><i class="fa fa-chevron-right" aria-hidden="true"></i> Products</a></li> */}
            <li><a href="/career"><i class="fa fa-chevron-right" aria-hidden="true"></i> Careers</a></li>
            <li><a href="/contacts"><i class="fa fa-chevron-right" aria-hidden="true"></i> Contact</a></li>
          </ul>
        </div>

        {/* Address Section */}
        <div className="footer-address">
          <h4>Head Office</h4>
          <p>#37A Ramnagar 1st Street, Tirupur, India 641602</p>
          <p>Phone: +91-9865233369</p>
          {/* <p>Email: support@sskvtechbuilds.com</p> */}
        </div>

        {/* Franchise Locations */}
        <div className="footer-address">
          <h4>Other Locations</h4>
          <div className="franchise-locations">
            <div>
              <strong>Chennai:</strong>
              <p>#9/2, Vivekananda St, Arumbakkam, Chennai, India 600106</p>
              <p><span>Phone:</span><span>+91-7448465556</span> </p>
              {/* <p>Email: support@sskvtechbuilds.com</p> */}
            </div>
            <div>
              <strong>Bengaluru:</strong>
              <p>#4, 21st, Narayana Nagar 1st Block, Konanakunte, Bengaluru, India 560062</p>
              <p>Phone: +91-9449138831</p>
            </div>
            <div>
              <strong>Coimbatore:</strong>
              <p>#1, 1st Floor, RG Pudur Pirivu, Above MRF Tyre Showroom, Chinniyampalayam, Coimbatore - 641 062, Tamilnadu, India.</p>
              <p>Phone: +91-94451 05983</p>
            </div>
            <div>
              <strong>Hyderabad:</strong>
              <p>2-22-85/B, Allwyn colony rd, Vivekananda Nagar, Kukatpally, Hyderabad, Telangana 500072 .</p>
              <p>Phone: +91-94451 05983</p>
            </div>
          </div>
        </div>


        <div className="footer-address">
          <h4>Mail Address</h4>
          <p>info@groupsui.in</p>
          
        </div>

       
      </div>


      <div >
        <p>&copy; 2024 SSKV Techbuilds. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
